import { render, staticRenderFns } from "./FileTypeList.vue?vue&type=template&id=1330b921&scoped=true"
import script from "./FileTypeList.vue?vue&type=script&lang=js"
export * from "./FileTypeList.vue?vue&type=script&lang=js"
import style0 from "./FileTypeList.vue?vue&type=style&index=0&id=1330b921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1330b921",
  null
  
)

export default component.exports